import React, { Component } from "react";
import mainImage from "../../assests/images/11.jpg";

export default class EducationImg extends Component {
  render() {
    return <img src={mainImage} alt="Feeling Proud" />;
  }
}
